/**
 * Permissões reais do painel — mesmas chaves usadas pelas rotas (allRoutes.js),
 * pelo menu (platformMenu.js) e pelo backend (platformPermissionDefaults.js).
 */

export const PERMISSION_LABELS = [
    { key: "platform_dashboard", label: "Visão Geral (Dashboard)" },
    { key: "platform_crm", label: "CRM de Leads B2B" },
    { key: "platform_tenants", label: "Clientes / Academias" },
    { key: "platform_portfolio", label: "Carteira de Clientes (CS)" },
    { key: "platform_billing", label: "Financeiro SaaS / Faturas" },
    { key: "platform_mercadopago", label: "Mercado Pago (Gateway)" },
    { key: "platform_support", label: "Suporte / Chamados" },
    { key: "platform_onboarding", label: "Onboarding / Implantação" },
    { key: "platform_plans", label: "Planos Comerciais" },
    { key: "platform_users", label: "Usuários Internos" },
    { key: "platform_permissions", label: "Matriz de Permissões" },
    { key: "platform_audit", label: "Auditoria / Logs" },
    { key: "platform_metrics", label: "Métricas de Uso" },
    { key: "platform_notifications", label: "Notificações Automáticas" },
    { key: "platform_settings", label: "Configurações do SaaS" },
];

export const ROLE_LABELS = {
    owner: "Owner",
    admin: "Administrador",
    financeiro: "Financeiro",
    suporte: "Suporte",
    comercial: "Comercial",
    vendas: "Consultor de Vendas",
    cs: "Customer Success",
};
